// Built by hand rather than with Intl: en-GB abbreviates September as "Sept", the design uses three letters throughout.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const pad = (n: number) => String(n).padStart(2, '0');

/** "14:00" */
export const formatTime = (d: Date) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;
/** "08:12:00" */
export const formatTimeSeconds = (d: Date) => `${formatTime(d)}:${pad(d.getSeconds())}`;
/** "29 Sep" */
export const formatDayMonth = (d: Date) => `${d.getDate()} ${MONTHS[d.getMonth()]}`;
/** "29 Sep, 14:00" */
export const formatDayMonthTime = (d: Date) => `${formatDayMonth(d)}, ${formatTime(d)}`;
/** "29 Sep 2026, 14:00" */
export const formatDateTime = (d: Date) => `${formatDayMonth(d)} ${d.getFullYear()}, ${formatTime(d)}`;
/** "2026-09-30T08:12:00Z" */
export const formatIsoSeconds = (d: Date) => d.toISOString().replace(/\.\d{3}Z$/, 'Z');

export const formatFixed = (value: number | null | undefined, decimals: number, empty = '—') =>
  value === null || value === undefined || !Number.isFinite(value) ? empty : value.toFixed(decimals);

/** "+0.3" / "−0.3" with a real minus sign, as in the design. */
export const formatDelta = (value: number, decimals: number) =>
  (value >= 0 ? '+' : '−') + Math.abs(value).toFixed(decimals);

export type AgoUnit = { key: 'now' } | { key: 'minutes' | 'hours' | 'days'; count: number };

export const agoUnit = (from: Date, now: Date = new Date()): AgoUnit => {
  const minutes = Math.floor((now.getTime() - from.getTime()) / 60000);
  if (minutes < 1) return { key: 'now' };
  if (minutes < 60) return { key: 'minutes', count: minutes };
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return { key: 'hours', count: hours };
  return { key: 'days', count: Math.floor(hours / 24) };
};
